export default __webpack_public_path__ + "static/media/avatar.1acd9d47.png";